export enum OverviewHistoryType {
  MONTHLY_KPIS = 'monthly-kpis',
  PROJECTS_LAUNCHED = 'projects-launched',
  EMPLOYEE_LEADERBOARD = 'employee-leaderboard',
  BEST_PERFORMER = 'best-performer',
  TEAM_LEADS = 'team-leads',
  SPEED_OF_DELIVERY = 'speed-of-delivery',
}

export enum OverviewMonthlyKpiKey {
  REQUESTED = 'requested',
  COMPLETED = 'completed',
  DELIVERED = 'delivered',
  ACTIVE_PROJECTS = 'activeProjects',
}

export enum OverviewProjectLaunchTeamKey {
  US = 'us',
  APAC = 'apac',
  EMEA = 'emea',
}
